<template>
    <div>
        <el-tabs v-model="query.search_status" @tab-click="handleSearch">
            <el-tab-pane label="上架" name="1"></el-tab-pane>
            <el-tab-pane label="下架" name="2"></el-tab-pane>
        </el-tabs>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="输入要搜索的内容" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
            </template>
            <template slot="btns" v-if="permission('nrgl_banner_xz')">
                <el-button size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
            </template>
            <template slot="columns">
                <el-table-column label="序号" align="center" prop="sort" />
                <el-table-column label="图片" align="center">
                    <template slot-scope="{ row }">
                        <img @click="handlePreview(row.image)" :src="ossUrl + row.image" style="height: 60px" />
                    </template>
                </el-table-column>
                <el-table-column label="上传日期" align="center" prop="create_time" />
                <el-table-column
                    v-if="
                        permission('nrgl_banner_bj') ||
                        permission(row.status == 1 ? 'nrgl_banner_xj' : 'nrgl_banner_sj') ||
                        permission('nrgl_banner_sc')
                    "
                    label="操作"
                    align="center"
                    width="200"
                >
                    <template slot-scope="{ row }">
                        <el-button v-if="permission('nrgl_banner_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                        <el-button
                            v-if="permission(row.status == 1 ? 'nrgl_banner_xj' : 'nrgl_banner_sj')"
                            size="mini"
                            type="text"
                            @click="handleUpdate(row)"
                        >
                            {{ row.status == 1 ? "下架" : "上架" }}
                        </el-button>
                        <el-button v-if="permission('nrgl_banner_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <PicPreviewer ref="preview"></PicPreviewer>
    </div>
</template>

<script>
import { list, del, edit } from "@/api/content/banner";
import listMixin from "@/mixins/list";
import { ossUrl } from "@/configs/oss";
import PicPreviewer from "@/components/PicPreviewer";

export default {
    components: { PicPreviewer },
    data() {
        return {
            list,
            del,
            ossUrl,
            // 查询参数
            query: {
                search_status: "1",
                search_keyword: "",
            },
            module: "banner",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleAdd() {
            this.$router.push({ path: "/content/banner/form" });
        },
        handleEdit(row) {
            this.$router.push({ path: "/content/banner/form", query: { uuid: row.uuid } });
        },
        handlePreview(url) {
            this.$refs.preview.open(url);
        },
        handleUpdate(row) {
            edit({ uuid: row.uuid, ...row, status: row.status == 1 ? 2 : 1 }).then(({ code, error }) => {
                if (code == 200) {
                    this.search();
                    this.$message.success(row.status == 1 ? "下架成功" : "上架成功");
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>
